import React from "react";
import { SectionShell, Field, CheckboxGroup } from "./PartnerFormPrimitives";
import { PAYMENT_METHODS } from "./partnerConstants";
import { toggleInArray } from "./partnerHelpers";

export default function PartnerPaymentSignature({ data, set, setRaw }) {
  const togglePayment = (v) => setRaw("payment_methods", toggleInArray(data.payment_methods, v));

  const fullSignerName = [
    data.signer_first_name,
    data.signer_middle_name,
    data.signer_last_name,
  ].filter(Boolean).join(" ").trim();
  const sigMatches = data.typed_signature && fullSignerName && data.typed_signature.trim().toLowerCase() === fullSignerName.toLowerCase();

  return (
    <SectionShell
      index={8}
      title="Payment Preferences & Electronic Signature"
      subtitle="How we'll pay you, and your signed acknowledgement."
      testId="partner-section-payment"
    >
      <Field label="Preferred Payment Method(s)" required>
        <CheckboxGroup
          options={PAYMENT_METHODS}
          value={data.payment_methods}
          onChange={togglePayment}
          columns={3}
          testIdPrefix="partner-pay"
        />
      </Field>
      {data.payment_methods.includes("Other") && (
        <Field label="Other Payment Method">
          <input className="input-br" value={data.payment_methods_other} onChange={set("payment_methods_other")} />
        </Field>
      )}

      <div className="divider-bronze" />

      <div className="grid sm:grid-cols-3 gap-3">
        <Field label="Signer First Name" required>
          <input className="input-br" value={data.signer_first_name} onChange={set("signer_first_name")} required />
        </Field>
        <Field label="Middle Name">
          <input className="input-br" value={data.signer_middle_name} onChange={set("signer_middle_name")} />
        </Field>
        <Field label="Signer Last Name" required>
          <input className="input-br" value={data.signer_last_name} onChange={set("signer_last_name")} required />
        </Field>
      </div>

      <Field
        label="Electronic Signature"
        required
        hint={fullSignerName ? `Re-type your full legal name exactly: "${fullSignerName}"` : "Type your full legal name as signed above"}
      >
        <input
          className={`input-br ${sigMatches ? "border-emerald-500" : ""}`}
          value={data.typed_signature}
          onChange={set("typed_signature")}
          required
          style={{ fontFamily: "'Playfair Display', serif", fontSize: "1.1rem", fontStyle: "italic" }}
          data-testid="partner-typed-signature"
        />
      </Field>

      <Field label="Signature Date" required>
        <input type="date" className="input-br" value={data.signature_date} onChange={set("signature_date")} required />
      </Field>

      <label className="flex items-start gap-2 text-xs text-gray-700 bg-br-paper/60 border border-gray-200 rounded p-3 cursor-pointer">
        <input
          type="checkbox"
          className="accent-br-bronze mt-0.5"
          checked={data.esign_acknowledged}
          onChange={(e) => setRaw("esign_acknowledged", e.target.checked)}
          data-testid="partner-esign-ack"
        />
        <span>
          I acknowledge that typing my full legal name above and clicking Submit constitutes a legally binding electronic signature under the U.S. E-SIGN Act (15 U.S.C. § 7001), and I certify that all information provided in this application is true and accurate to the best of my knowledge.
        </span>
      </label>
    </SectionShell>
  );
}
